/**
 * @file: The interval behind a bar in the grid.
 *
 * FullCalendar puts no id on the element that it draws. eventDidMount is the
 * documented hook that gets the element and the event together. markIntervalId
 * writes the interval id on the element there, and intervalIdOf reads it. The
 * selection outline and the right-click menu use this attribute. They do not
 * use a private field of FullCalendar.
 */

/**
 * Write the interval id of the event on its element.
 *
 * @param {Object} arg - The eventDidMount argument of FullCalendar
 */
function markIntervalId ({ event, el }) {
  const intervalId = event && event.extendedProps && event.extendedProps.intervalId

  if (!el || intervalId === null || intervalId === undefined) {
    return
  }

  el.dataset.intervalId = String(intervalId)
}

/**
 * The interval id that markIntervalId wrote on an element.
 *
 * @param {HTMLElement} eventEl - An element FullCalendar drew for an event
 * @returns {string|null} The id as text, or null when the element has none
 */
function intervalIdOf (eventEl) {
  return (eventEl && eventEl.dataset && eventEl.dataset.intervalId) || null
}

export { markIntervalId, intervalIdOf }
